export const permissionGroups = [
   
    {
        name: "Sales",
        subPermissions: ["Create Lead", "Read Lead", "Update Lead", "Delete Lead"],
    },
    {
        name: "Students",
        subPermissions: ["Create Student", "Read Student", "Update Student", "Delete Student"],
    },
    {
        name: "Instructors",
        subPermissions: ["Approve User", "Read Users", "Update User"],
    },
   
    {
        name: "DOT Compliance",
        subPermissions: ["View", "Notes", "Activity", "Business Info"],
        isSubPermission: true,
    },
    {
        name: "Human Resources",
        subPermissions: ["View", "Notes", "Activity", "Add More","Delete"],
        isSubPermission: true,
    },
    {
        name: "Biz Partners",
        subPermissions: ["View", "Notes", "Activity", "Business Info"],
        isSubPermission: true,
    },
    {
        name: "Accounting",
        subPermissions: ["AP", "Invoicing", "Expenses", "Account Reports"],
    },
    {
        name: "Demo",
        subPermissions: ["Create", "Read", "Update", "Delete"],
    },
    {
        name: "Candidates",
        subPermissions: ["Create", "Read", "Update", "Delete"],
    },
    {
        name: "Recordings",
        subPermissions: ["Read", "Update", "Close"],
    },
   
    {
        name: "Courses",
        subPermissions: ["Section Delete","Content"],
        isSubPermission: true,
    },
    {
        name: "Task Manager",
        subPermissions: ["Read", "Write","Update"],
    },
  
    {
        name: "User Biz",
        subPermissions: ["Read", "Write","Update"],
    },
];
